<template>
    <div class="sensitive-degree-edit">
        <v-radio-group v-model="sensitiveDegreeRadio">
            <v-radio
                name="radio"
                value="3"
            >
                <span class="sensitive-degree-edit__content">{{ $t('仅留存记录') }}</span>
            </v-radio>
            <!-- <span class="sensitive-degree-edit__space"></span> -->
            <!-- <v-radio name="radio" value="2">提示但不拦截</v-radio> -->
            <span class="sensitive-degree-edit__space" />
            <v-radio
                name="radio"
                value="1"
            >
                <span class="sensitive-degree-edit__content">{{ $t('消息拦截') }}</span>
            </v-radio>
            <span class="sensitive-degree-edit__space" />
            <v-radio
                v-if="currentType === 3"
                name="radio"
                value="4"
            >
                <span class="sensitive-degree-edit__content">{{ $t('消息替换过滤为*') }}</span>
            </v-radio>
        </v-radio-group>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
/* eslint-disable */
const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
export default {
    name: 'SensitiveDegreeEdit',
    props: {
        value: {
            type: String,
            default() {
                return '3';
            }
        },
        currentType: {
            type: Number,
            default: 1,
        }
    },
    data() {
        return {
            sensitiveDegreeRadio: this.value
        };
    },
    computed: {},
    watch: {
        value(newVal) {
            this.sensitiveDegreeRadio = newVal;
        },
        sensitiveDegreeRadio(newVal) {
            this.$emit('input', newVal);
        }
    },
    methods: {}
};
</script>

<style lang="less">
@import '~@/common/common.less';

.sensitive-degree-edit {
    margin-top: -4px;
    // .v-radio {
    //     &__inner {
    //         width: 18px;
    //         height: 18px;
    //     }
    //     &__label {
    //         margin-left: 7px;
    //         height: 18px;
    //         float: left;
    //         line-height: 18px;
    //     }
    // }
    // &__space {
    //     display: inline-block;
    //     width: 63px;
    // }
    // &__content {
    //     margin-left: 3px;
    // }
    // .v-icon {
    //     width: 18px;
    //     height: 18px;
    // }
}
</style>
